import script from "./dialGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./dialGauge.vue?vue&type=script&setup=true&lang=js"

import "./dialGauge.vue?vue&type=style&index=0&id=a74b3c04&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a74b3c04"]])

export default __exports__